import { useState, useReducer } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import {
  CommonLabel,
  ContentWrapper,
  InputAndLabelWrapper,
  InputRowWrapper,
  LabelAndInfoWrapper,
} from "../styles";
import CustomSelect from "../inputs/CustomSelect";
import InfoButton from "../../../../shared/button/InfoButton";
import { InfoModal } from "../../../../shared/modals/InfoModal";
import { useTranslation } from "react-i18next";
import { FATCA_TAX_CLASS_OTHER } from "./utils";
import TextInputWithLanguageControl from "../inputs/TextInputWithLanguageControl";

function Fatca(props) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { texClassifications } = props;

  const { t } = useTranslation();

  const {
    register,

    unregister,
  } = useFormContext();

  const fatcaTaxClassValue = useWatch({
    name: "fatca.taxClassifications",
  });
  const fatcaAgreementValue = useWatch({
    name: "fatca.agreement",
  });

  const isOtherTaxClassification =
    fatcaTaxClassValue?.value === FATCA_TAX_CLASS_OTHER;

  function handleTaxClassificationChange(option) {
    const val = option?.value;
    if (val !== FATCA_TAX_CLASS_OTHER) {
      unregister("fatca.otherTaxClassifications");
    }
  }

  const [infoModal, setInfoModal] = useReducer(
    (info, newInfo) => ({ ...info, ...newInfo }),
    { heading: "", body: "" },
  );

  function toggleModal() {
    setModalIsOpen(false);
  }

  function handleTinInput(e) {
    const el = e.currentTarget;
    el.value = el.value.replace(/\D/g, "").slice(0, 9);
  }

  return (
    <ContentWrapper>
      <InputRowWrapper>
        <InputAndLabelWrapper>
          <TextInputWithLanguageControl
            name="fatca.tinNumber"
            label={t("TIN")}
            rules={{
              required: t("required"),
              minLength: {
                value: 9,
                message: t("fatca_tinnumber_length_validation"),
              },
              maxLength: {
                value: 9,
                message: t("fatca_tinnumber_length_validation"),
              },
            }}
            showNonEmptyError
            maxLength={9}
            placeholder="000-00-0000"
            onInput={handleTinInput}
            customLabel={
              <LabelAndInfoWrapper>
                <CommonLabel htmlFor="fatca.tinNumber">
                  {t("fatca_TIN")}
                </CommonLabel>
              </LabelAndInfoWrapper>
            }
          />
        </InputAndLabelWrapper>
      </InputRowWrapper>
      <InfoModal
        isOpen={modalIsOpen}
        onToggle={toggleModal}
        heading={infoModal.heading}
        body={infoModal.body}
      />
    </ContentWrapper>
  );
}
export default Fatca;
